import React, { useState, useEffect, Fragment } from 'react'
import { Link } from 'react-router-dom'
import { Dropdown, Nav, NavDropdown } from 'react-bootstrap'
import BuyModal from '../components/layouts/BuyModal'
import useMarketplaceStore from '../stores/marketplaceStore'
import Header from '../components/header/Header'
import MarketplaceSideBar from '../components/layouts/MarketplaceSideBar'
import csgoCategories from '../assets/fake-data/data-csgo-categories'
import { formatPrice } from '../utils/format'


const Marketplace = () => {
    const {
        fetchItems,
        items,
        filters,
        setFilters,
        searchTerm,
        setSearchTerm,
        minPrice,
        setMinPrice,
        maxPrice,
        setMaxPrice,
        sortOrder,
        setSortOrder,
        addToCart,
    } = useMarketplaceStore()

    const [visible, setVisible] = useState(8)
    const [modalShow, setModalShow] = useState(false)
    const [modalItem, setModalItem] = useState(null)
    const [filteredItems, setFilteredItems] = useState([])
    const [selectedCategory, setSelectedCategory] = useState(null)
    const [selectedCategoryItem, setSelectedCategoryItem] = useState(null)

    useEffect(() => {
        fetchItems()
    }, [])

    const applyFiltersAndUpdateState = () => {
        if (!items) {
            setFilteredItems([])
            return
        }

        let filtered = items.filter((item) => {
            const matchExterior = filters.exterior.includes('Any') || filters.exterior.includes(item.exterior)
            const matchPhase = filters.phase.includes('Any') || filters.phase.includes(item.phase)
            const matchSearch = item.name.toLowerCase().includes(searchTerm.toLowerCase())
            const matchPrice =
                (!minPrice || item.price >= parseFloat(minPrice)) && (!maxPrice || item.price <= parseFloat(maxPrice))
            const matchCategory = !selectedCategory || item.item_type === selectedCategory
            const matchCategoryItemName = !selectedCategoryItem || item.name.includes(selectedCategoryItem)

            return matchExterior && matchPhase && matchSearch && matchPrice && matchCategory && matchCategoryItemName
        })

        if (sortOrder) {
            filtered = filtered.sort((a, b) => {
                switch (sortOrder) {
                    case 'price-high-to-low':
                        return b.price - a.price
                    case 'price-low-to-high':
                        return a.price - b.price
                    case 'float-high-to-low':
                        return b.float_num - a.float_num
                    case 'float-low-to-high':
                        return a.float_num - b.float_num
                    case 'discount-high-to-low':
                        return b.discount - a.discount
                    case 'discount-low-to-high':
                        return a.discount - b.discount
                    default:
                        return 0
                }
            })
        }

        setFilteredItems(filtered)
    }

    useEffect(() => {
        applyFiltersAndUpdateState()
    }, [items, filters, searchTerm, minPrice, maxPrice, sortOrder, selectedCategory, selectedCategoryItem])

    const showMoreItems = () => {
        setVisible((prevValue) => prevValue + 5)
    }

    const handleOpenModal = (item) => {
        setModalShow(true)
        setModalItem(item)
    }

    const handleCategorySelect = (category, e) => {
        e.stopPropagation()

        if (selectedCategory == category.name) {
            setSelectedCategory(null)
            setSelectedCategoryItem(null)
            return
        }

        setSelectedCategory(category.name)

        if (selectedCategoryItem) {
            const itemExistsInCategory = category.items.some((item) => item.name === selectedCategoryItem)
            if (!itemExistsInCategory) {
                setSelectedCategoryItem(null)
            }
        }
    }

    const handleItemSelect = (categoryName, categoryItemName, e) => {
        e.stopPropagation()

        if (selectedCategoryItem == categoryItemName) {
            setSelectedCategoryItem(null)
            return
        }

        setSelectedCategory(categoryName)
        setSelectedCategoryItem(categoryItemName)
    }

    const handleAddToCart = (item) => {
        addToCart(item)
    }

    return (
        <div className="home-8 s3skin-marketplace">
            <Header />
            <section className="tf-item tf-section">
                <div className="themesflat-container">
                    <div className="row">
                        <div className="col-box-17">
                            <MarketplaceSideBar filters={filters} onFilterChange={setFilters} />
                        </div>
                        <div className="col-box-83">
                            <Fragment>
                                <div className="flat-tabs items">
                                    <Nav activeKey="1" variant="pill">
                                        {csgoCategories.map((category) => (
                                            <NavDropdown
                                                title={category.name}
                                                className={`category-dropdown ${category.items.length <= 5 ? 'single-col' : ''} ${category.name === selectedCategory ? 'selected' : ''}`}
                                                id={`nav-dropdown-${category.key}`}
                                                key={category.key}
                                                onClick={(e) => handleCategorySelect(category, e)}
                                                renderMenuOnMount={true}
                                            >
                                                {category.items.map((item) => (
                                                    <NavDropdown.Item
                                                        key={item.key}
                                                        eventKey={item.key}
                                                        className={
                                                            item.name === selectedCategoryItem ? 'selected-item' : ''
                                                        }
                                                        onClick={(e) => handleItemSelect(category.name, item.name, e)}
                                                    >
                                                        {item.name}
                                                    </NavDropdown.Item>
                                                ))}
                                            </NavDropdown>
                                        ))}
                                    </Nav>
                                    <div className="marketlist">
                                        <h2 className="title">{filteredItems.length} vật phẩm</h2>
                                        <div className="option">
                                            <h3 className="title">Tên vật phẩm</h3>
                                            <div className="widget widget-search mgbt-24 col-3">
                                                <input
                                                    type="text"
                                                    placeholder="Tìm kiếm..."
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                            <h3 className="title">Giá</h3>
                                            <div className="widget widget-search mgbt-24 col-2">
                                                <input
                                                    type="text"
                                                    pattern="[0-9]*"
                                                    placeholder="100,000 vnđ"
                                                    step={0}
                                                    value={minPrice}
                                                    onChange={(e) => setMinPrice(e.target.value)}
                                                />
                                            </div>{' '}
                                            -
                                            <div className="widget widget-search mgbt-24 col-2">
                                                <input
                                                    placeholder="500,000 vnđ"
                                                    type="text"
                                                    pattern="[0-9]*"
                                                    value={maxPrice}
                                                    onChange={(e) => setMaxPrice(e.target.value)}
                                                />
                                            </div>
                                            <div className="view">
                                                <Dropdown onSelect={setSortOrder}>
                                                    <Dropdown.Toggle
                                                        id="dropdown-basic"
                                                        className="btn-sort-by dropdown"
                                                    >
                                                        <svg
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M3 7H21"
                                                                stroke="white"
                                                                strokeWidth="1.5"
                                                                strokeLinecap="round"
                                                            ></path>
                                                            <path
                                                                d="M6 12H18"
                                                                stroke="white"
                                                                strokeWidth="1.5"
                                                                strokeLinecap="round"
                                                            ></path>
                                                            <path
                                                                d="M10 17H14"
                                                                stroke="white"
                                                                strokeWidth="1.5"
                                                                strokeLinecap="round"
                                                            ></path>
                                                        </svg>
                                                        <span>Sắp xếp</span>
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu style={{ margin: 0 }}>
                                                        <Dropdown.Item eventKey="price-high-to-low">
                                                            Giá giảm dần
                                                        </Dropdown.Item>
                                                        <Dropdown.Item eventKey="price-low-to-high">
                                                            Giá tăng dần
                                                        </Dropdown.Item>
                                                        <Dropdown.Item eventKey="float-high-to-low">
                                                            Float giảm dần
                                                        </Dropdown.Item>
                                                        <Dropdown.Item eventKey="float-low-to-high">
                                                            Float tăng dần
                                                        </Dropdown.Item>
                                                        <Dropdown.Item eventKey="discount-high-to-low">
                                                            Giảm giá nhiều nhất
                                                        </Dropdown.Item>
                                                        <Dropdown.Item eventKey="discount-low-to-high">
                                                            Giảm giá ít nhất
                                                        </Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </div>

                                        <div className="content-item open">
                                            {filteredItems.length === 0 ? (
                                                <div className="col-item">
                                                    <p>Không có vật phẩm nào.</p>
                                                </div>
                                            ) : (
                                                filteredItems.slice(0, visible).map((item, key) => (
                                                    <div key={key} className="col-item">
                                                        <div className="sc-card-product menu_card style-h7">
                                                            <div className="meta-info style">
                                                                <Link
                                                                    to="#"
                                                                    className="wishlist-button available"
                                                                ></Link>
                                                                <Link to="#" className="wishlist-button lock"></Link>
                                                            </div>
                                                            <div className="card-media">
                                                                {item.images[0] ? (
                                                                    <img src={item.images[0].url} alt={item.name} />
                                                                ) : (
                                                                    ''
                                                                )}
                                                            </div>
                                                            <div className="card-title">
                                                                <h6>{item.name}</h6>
                                                            </div>
                                                            <div className="meta-info">
                                                                <div className="author">
                                                                    <div className="info">
                                                                        <span className="pricing">{item.exterior}</span>
                                                                    </div>
                                                                </div>
                                                                <div className="author">
                                                                    <div className="info">
                                                                        <span className="pricing">
                                                                            {item.float_num}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="meta-info">
                                                                <div className="author">
                                                                    <div className="info">
                                                                        <span>Giá </span>
                                                                        <span className="pricing">{formatPrice(item.price)}</span>
                                                                        <span className="currency"> vnđ </span>
                                                                    </div>
                                                                </div>
                                                                <div className="discount-percent">
                                                                    -{item.discount}%
                                                                </div>
                                                            </div>
                                                            <div className="card-bottom">
                                                                <button
                                                                    onClick={() => handleAddToCart(item)}
                                                                    className="sc-button style bag fl-button pri-3 no-bg"
                                                                >
                                                                    <span></span>
                                                                </button>
                                                                <button
                                                                    onClick={() => handleOpenModal(item)}
                                                                    className="sc-button fl-button pri-3 no-bg"
                                                                >
                                                                    <span>Mua ngay</span>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            )}
                                            {filteredItems.length > visible && (
                                                <div className="col-md-12 wrap-inner load-more text-center btn-auction item center">
                                                    <Link
                                                        to="#"
                                                        className="sc-button loadmore fl-button pri-3"
                                                        onClick={showMoreItems}
                                                    >
                                                        <span>Hiển thị thêm</span>
                                                    </Link>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Fragment>
                        </div>
                    </div>
                </div>
            </section>
            {modalItem && <BuyModal show={modalShow} onHide={() => setModalShow(false)} item={modalItem} />}
        </div>
    )
}

export default Marketplace
